export const DEVICE_STATUS = {
  NotConnected: -1,
  Connected: 0,
  Menu: 1,
  Test: 2,
  Calibration: 3,
  Tutorial: 4,
} as const;

export function isMenuScene(scene: unknown): boolean {
  return typeof scene === "string" && scene.trim().toLowerCase() === "menu";
}

export function isCalibrationScene(scene: unknown): boolean {
  if (typeof scene !== "string") {
    return false;
  }

  return scene.trim().toLowerCase().includes("calibration");
}

export function isTutorialScene(scene: unknown): boolean {
  if (typeof scene !== "string") {
    return false;
  }

  return scene.trim().toLowerCase().includes("tutorial");
}

export function isDeviceBusyStatus(status: number | null | undefined): boolean {
  return (
    status === DEVICE_STATUS.Test ||
    status === DEVICE_STATUS.Calibration ||
    status === DEVICE_STATUS.Tutorial
  );
}

export function getDeviceStatus(scene, lastInteraction, isTutorialActive?: boolean) {
  if (scene) {
    if (isCalibrationScene(scene)) {
      return DEVICE_STATUS.Calibration;
    } else if (isTutorialActive || isTutorialScene(scene)) {
      return DEVICE_STATUS.Tutorial;
    } else if (scene === "Test" || (scene !== "" && scene !== "Menu")) {
      // :(
      return DEVICE_STATUS.Test;
    } else if (scene === "Menu") {
      return DEVICE_STATUS.Menu;
    }
  } else if (lastInteraction) {
    return DEVICE_STATUS.Connected;
  } else {
    return DEVICE_STATUS.NotConnected;
  }
}

// The 15s REST scene-poll fallback (used while the tab was backgrounded and
// misses live websocket pushes) has no isTutorialActive flag to work with, so
// it can only ever compute a coarse Test/Menu/etc status. Without this guard,
// resuming the poll on tab foreground would stamp the badge back to Test the
// instant it fires, even mid-tutorial, until the next live push corrects it.
export function preserveKnownSubstatus(
  computedStatus: number,
  currentStatus: number | null | undefined,
): number {
  if (
    computedStatus === DEVICE_STATUS.Test &&
    (currentStatus === DEVICE_STATUS.Tutorial || currentStatus === DEVICE_STATUS.Calibration)
  ) {
    return currentStatus;
  }
  return computedStatus;
}

export function isDeviceInTestingState(scene, status) {
  if (isDeviceBusyStatus(status)) {
    return true;
  }

  if (typeof scene !== "string") {
    return false;
  }

  const normalizedScene = scene.trim().toLowerCase();
  return normalizedScene !== "" && normalizedScene !== "menu";
}
